import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardModuleHorizontal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 45 38",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Liggende_kortmodul",
		"data-name": "Liggende kortmodul",
		transform: "translate(-5.5 -3.5)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "layout--row-vertical",
			transform: "translate(6 6)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-path",
					width: 44,
					height: 11,
					transform: "translate(0 -2)",
					stroke: "#fff",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-path-2",
					"data-name": "Rectangle-path",
					width: 44,
					height: 11,
					transform: "translate(0 11)",
					stroke: "#fff",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-path-3",
					"data-name": "Rectangle-path",
					width: 44,
					height: 11,
					transform: "translate(0 24)",
					stroke: "#fff",
					strokeWidth: 1
				})
			]
		})
	})
});
export default SvgCardModuleHorizontal;
